import Vue from 'vue'
import moment from "moment";

Vue.filter('numberWithCommas', function (x) {
    return ((x).toFixed(2).toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$2,')) + '€';
})

Vue.filter('formatDate', function (x) {
    return moment(x).format('dddd Do MMMM , HH:mm');
})

Vue.filter('hourFormat', function (x) {
    return moment(x).format('HH:mm');
})


Vue.filter('formatDateShort', function (x) {
    return moment(x).format('DD/MM/YYYY');
})

Vue.filter('dateNotification', function (x) {
    return moment(x).format('dddd DD MMMM YYYY, HH:mm');
})

Vue.filter('initial', function (firstname,lastname) {
    const initials = firstname.charAt(0) + lastname.charAt(0);
    return initials.toUpperCase();
})

Vue.filter('interval', function (date) {
    return moment(date).fromNow();
})

// Notifications
const notification = [
    { type: 'order', alert:'alert-info', icon: '🌮' },
    { type: 'error', alert:'alert-danger', icon: '😵' },
    { type: 'warning', alert: 'alert-warning', icon:'😰'},
    { type: 'success', alert: 'alert-success', icon: '🎉'}
]
Vue.filter('iconAlert', function (type) {
    const obj = notification.find(status => status.type === type)
    return obj.icon;
})
Vue.filter('alert', function (type) {
    const obj = notification.find(status => status.type === type)
    return obj.alert;
})

